import { Box, Drawer } from '@material-ui/core';
import { useEffect, useState } from 'react';

import { PricingFormWrapper } from '@/components/modules/PricingCreate/components/PricingFormWrapper';
import { PricingSpecDataFormSchema } from '@/components/modules/PricingCreate/schemas/PricingSpecDataFormSchema';
import { PricingSpecFormFields } from '@/components/modules/PricingEditor/components/PricingSpecFormFields';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

import { usePricingEditor } from '../hooks/usePricingEditor';
import { PricingSpecFormValues } from '../types/PricingSpecFormValues';
import { PricingSpecSearchSwitch } from './PricingSpecSearchSwitch';

interface PricingSpecFormProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pricingId: string;
}

export const PricingSpecForm = ({ open, setOpen, pricingId }: PricingSpecFormProps) => {
  const { createOrGetPricingSpecAndAddToPricing, loading } = usePricingEditor(pricingId);

  const [moreOptions, setMoreOptions] = useState(false);
  const [pricingSpecSearchEnabled, setPricingSpecSearchEnabled] = useState(true);

  const onSubmitForm = async (data: PricingSpecFormValues) => {
    await createOrGetPricingSpecAndAddToPricing(data, pricingSpecSearchEnabled);
    setOpen(false);
  };

  useEffect(() => {
    if (open === false) {
      setMoreOptions(false);
      setPricingSpecSearchEnabled(true);
    }
  }, [open]);

  return (
    <Drawer anchor={'bottom'} open={open} onClose={() => setOpen(false)}>
      <Box p={6}>
        <Box mb={5} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <Font variant={'h3'} color={'title'}>
            <Text tId={'ADD_NEW_PRICING_SPEC'} />
          </Font>
          <PricingSpecSearchSwitch
            pricingSpecSearchEnabled={pricingSpecSearchEnabled}
            setPricingSpecSearchEnabled={setPricingSpecSearchEnabled}
          />
        </Box>
        <PricingFormWrapper
          formSchema={PricingSpecDataFormSchema}
          onSubmitForm={onSubmitForm}
          loading={loading}
          buttons={
            <StandardButton onClick={() => setMoreOptions(!moreOptions)}>
              <Text tId="MORE_OPTIONS" />
            </StandardButton>
          }
        >
          <PricingSpecFormFields moreOptions={moreOptions} />
        </PricingFormWrapper>
      </Box>
    </Drawer>
  );
};
